import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    if (!this.itemTarget.hasAttribute("tabindex")) {
      this.itemTarget.tabIndex = 0
    }
  }

  focus() {
    this.itemTarget.focus()
  }
}
